import { c as _c } from "react/compiler-runtime";
import { useCurrentUser } from '@hooks/useCurrentUser';
import { doesUserHavePermission } from '@lib/utils/doesUserHavePermission';
import { useJotaiValue } from '@states/jotai/hooks';
import { contactSelector } from '@states/softphone/contactSelector';
import type { TPermission } from '@lib/types/generated/TPermission';
import type { TResourceStatus } from '@lib/types/generated/TResourceStatus';
export type TPermissionRequest = {
  key: TPermission;
  resourceStatus?: TResourceStatus;
};
export function useHasPermission(key: TPermission, resourceStatus?: TResourceStatus): boolean;
export function useHasPermission(...requests: TPermissionRequest[]): boolean[];
export function useHasPermission(...t0) {
  const $ = _c(13);
  const args = t0;
  const {
    user
  } = useCurrentUser();
  const contact = useJotaiValue(contactSelector);
  const isSingleCheck = typeof args[0] === "string";
  let t1;
  if ($[0] !== args || $[1] !== isSingleCheck) {
    t1 = isSingleCheck ? [{
      key: args[0] as TPermission,
      resourceStatus: args[1] as TResourceStatus | undefined
    }] : args as TPermissionRequest[];
    $[0] = args;
    $[1] = isSingleCheck;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const requests = t1;
  if (user?.v2 == null) {
    let t2;
    if ($[3] !== isSingleCheck || $[4] !== requests) {
      t2 = isSingleCheck ? false : requests.map(_temp);
      $[3] = isSingleCheck;
      $[4] = requests;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  const isOnCall = contact.contactId != null && contact.contactMasterId !== null;
  let t2;
  if ($[6] !== isOnCall || $[7] !== requests || $[8] !== user) {
    let t3;
    if ($[10] !== isOnCall || $[11] !== user) {
      t3 = req => req != null && doesUserHavePermission(user.v2, req.key, {
        isOnCall,
        resourceStatus: req.resourceStatus
      });
      $[10] = isOnCall;
      $[11] = user;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = requests.map(t3);
    $[6] = isOnCall;
    $[7] = requests;
    $[8] = user;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const results = t2;
  return isSingleCheck ? results[0] : results;
}
function _temp() {
  return false;
}